import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { RecommenderIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathRecommenderOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.RECOMMENDER_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.RECOMMENDER_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.RECOMMENDER_MENU.OVERVIEW}
        menuName="Overview"
        icon="home"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathRecommenderAnalyticsDashboard();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.RECOMMENDER_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.RECOMMENDER_SIDEBAR.ANALYTICS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.RECOMMENDER_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-alt-2"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class RecommendersMenu extends React.Component {
  constructor (props) {
    super(props);
    this.recommendersUrl = paths.getPathRecommenders();
    this.recommenderSettingsUrl = paths.getPathRecommenderSettings();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.RECOMMENDER_MENU.RECOMMENDERS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.RECOMMENDER_SIDEBAR.RECOMMENDERS,
        label: "Manage Recommenders",
        href: this.recommendersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.recommendersUrl),
        isActive: activeSidebar === constants.RECOMMENDER_SIDEBAR.RECOMMENDERS
    }, {
        display: true,
        id: constants.RECOMMENDER_SIDEBAR.RECOMMENDER_SETTINGS,
        label: "Recommender Settings",
        href: this.recommenderSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.recommenderSettingsUrl),
        isActive: activeSidebar === constants.RECOMMENDER_SIDEBAR.RECOMMENDER_SETTINGS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.RECOMMENDER_MENU.RECOMMENDERS}
        menuName="Recommenders"
        icon="analyse"
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}




@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathRecommenderConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.RECOMMENDER_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.RECOMMENDER_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.RECOMMENDER_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}





@observer
class RecommenderSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_RECOMMENDER);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    return (
      <div className="sidebar sidebar-recommender">
        <div className="sidebar-head">
          <div className="head-icon"><RecommenderIcon /></div>
          <div className="head-title">Product Recommender</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <RecommendersMenu
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.RECOMMENDERS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_RECOMMENDER}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.RECOMMENDER_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_RECOMMENDER}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { RecommenderSidebar };

